const state = {
    selectedAgentObj: null,
 
};
const getters = {

    GET_SELECTED_AGENT: (state) => {
        return state.selectedAgentObj;
    },
  
 
};
const actions = {
    CLEAR_CREDIT_SALE_REPORT_STORE: ({ commit }) => {
        commit('clearCreditSaleReportStore');
    },
   
    SET_SELECTED_AGENT_OBJ: ({ commit }, selectedObj) => {
        commit("saveSelectedAgentObj", selectedObj);
    },
   
};

const mutations = {
    clearCreditSaleReportStore(state) {

        state.selectedAgentObj = null;
      
    },
    saveSelectedAgentObj(state, selectedObj) {
        state.selectedAgentObj = selectedObj;
    },
  

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};